export default [
	{
		key: 1,
		email: 'ceo@company.it',
		fullName: 'CEO - Mr. Emilio Ferrari',
		avatar: 'ceo'
	},
	{
		key: 2,
		email: 'salesmarketing@company.it',
		fullName: 'Dir. Marketing and Sales - Mrs. Giorgia Marchetti',
		avatar: 'sd'
	},
	{
		key: 3,
		email: 'cfo@company.it',
		fullName: 'CFO - Mr. Gianluca Fontana',
		avatar: 'cfo'
	},
	{
		key: 4,
		email: 'coo@company.it',
		fullName: 'COO - Mr. Federico Ricci',
		avatar: 'coo'
	}
];
